import { QRCodeSVG } from 'qrcode.react';
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import ReactDOMServer from "react-dom/server";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
function QRCodeExpediente({ link, header, expediente }) {

    const exportQrCode = async () => {
        try {
            const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
                <QRCodeSVG
                    value={link}
                    type="svg"
                />
            );

            const logoDataUrl = await getBase64FromUrl('/img/logo/logoArmed.png');

            const docDefinition = {
                pageSize: 'A5',
                pageMargins: [40, 60, 40, 60],
                content: [
                    {
                        columns: [
                            { width: '*', text: '' }, 
                            {
                                width: 'auto',
                                table: {
                                    widths: ['auto'],
                                    body: [
                                        [
                                            {
                                                stack: [
                                                    {
                                                        text: `Nº ${expediente?.numero}`,
                                                        fontSize: 20,
                                                        alignment: 'center',
                                                        margin: [0, 3, 0, 2]
                                                    },
                                                    {
                                                        svg: qrCodeSVG,
                                                        width: 100,
                                                        alignment: 'center',
                                                        margin: [0, 3, 0, 3]
                                                    },
                                                    {
                                                        image: logoDataUrl,
                                                        width: 80,
                                                        alignment: 'center',
                                                        margin: [0, 0, 0, 3]
                                                    }
                                                ],
                                                alignment: 'center'
                                            }
                                        ]
                                    ]
                                },
                                layout: {
                                    hLineWidth: () => 1,
                                    vLineWidth: () => 1,
                                    hLineColor: () => '#000000',
                                    vLineColor: () => '#000000'
                                }
                            },
                            { width: '*', text: '' } 
                        ]
                    }
                ]
            };

            pdfMake.createPdf(docDefinition).download(`QRCode_Expediente_${expediente?.numero}.pdf`);
        } catch (error) {
            
        }
    };

    const getBase64FromUrl = async (url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Erro ao converter imagem:', error);
            return '';
        }
    };

    return (
        <>
            {header &&
                <HeaderGestorConfigs
                    menu={true}
                    configArea={'qrCode'}
                    title={'CÓDIGO QR DO EXPEDIENTE'}
                    exportQrCode={exportQrCode}
                />
            }

            <div id='qrCode' style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center', border: '1px solid', borderRadius: 5, display: 'inline-block', padding: 10 }}>
                    <p style={{ paddingTop: 5, fontSize: 20 }}>Nº {expediente?.numero}</p>
                    <QRCodeSVG value={link} size={150} />
                    <br />
                    <img src="/img/logo/logoArmed.png" alt="ARMED" width={130} style={{ marginBottom: 15 }} />
                </div>
            </div>
        </>
    );
}

export default QRCodeExpediente;
